/* AMP3 Price Beat form (snippets/amp3-price-beat.liquid).
   Opens from the product page Price Beat tile (amp3-redesign.js), shows a Cloudflare Turnstile
   bot check, and posts JSON to the AMP3 Pricing app proxy: /apps/price-beat/request. */
(function () {
  'use strict';
  var TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
  var turnstileLoading = null;

  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (turnstileLoading) return turnstileLoading;
    turnstileLoading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = TURNSTILE_SRC; s.async = true; s.defer = true;
      s.onload = function () { resolve(window.turnstile); };
      s.onerror = function () { turnstileLoading = null; reject(new Error('turnstile')); };
      document.head.appendChild(s);
    });
    return turnstileLoading;
  }

  // The variant the customer has selected: the theme's on:variant:change event (custom.js),
  // falling back to the product form's id input, then the page's initial variant.
  var chosen = null;
  document.addEventListener('on:variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (v && v.id) chosen = { id: String(v.id), title: v.title && v.title !== 'Default Title' ? v.title : null };
  });
  function currentVariantId(dialog) {
    if (chosen) return chosen.id;
    var input = document.querySelector('.product-main form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    return (input && input.value) || dialog.querySelector('[name="variantId"]').value;
  }

  function setup(dialog) {
    if (dialog.dataset.a3PbReady) return;
    dialog.dataset.a3PbReady = '1';
    var form = dialog.querySelector('[data-a3-pb-form]');
    var errorBox = dialog.querySelector('[data-a3-pb-error]');
    var done = dialog.querySelector('[data-a3-pb-done]');
    var checkBox = dialog.querySelector('[data-a3-pb-turnstile]');
    var submit = form.querySelector('[type="submit"]');
    var sitekey = dialog.dataset.sitekey;
    var widgetId = null;
    var token = '';
    // Shops customers often name (11 Oct 2026): suggestions as they type, from the Pricing app's retailer list.
    var shops = dialog.querySelector('[data-a3-pb-shops]');
    var shopsLoaded = false;
    function loadShops() {
      if (shopsLoaded || !shops) return;
      shopsLoaded = true;
      fetch('/apps/price-beat/retailers', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : { retailers: [] }; }).then(function (j) {
        (j.retailers || []).forEach(function (s) {
          var o = document.createElement('option'); o.value = s.name; if (s.domain) o.label = s.domain; shops.appendChild(o);
        });
      }).catch(function () { shopsLoaded = false; });
    }

    function showError(msg, field) {
      errorBox.textContent = msg; errorBox.hidden = false;
      form.querySelectorAll('[aria-invalid]').forEach(function (n) { n.removeAttribute('aria-invalid'); });
      var input = field && form.querySelector('[name="' + field + '"]');
      if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
    }

    function renderCheck() {
      if (!sitekey || widgetId !== null) return;
      loadTurnstile().then(function (ts) {
        widgetId = ts.render(checkBox, {
          sitekey: sitekey,
          theme: 'light',
          callback: function (t) { token = t; },
          'expired-callback': function () { token = ''; },
          'error-callback': function () { token = ''; }
        });
      }).catch(function () { showError('The security check couldn’t load. Please check your connection, or contact us.'); });
    }

    // Opening: refresh the variant shown and start the bot check.
    var observer = new MutationObserver(function () {
      if (!dialog.open) return;
      loadShops();
      var label = dialog.querySelector('[data-a3-pb-variant]');
      if (label && chosen) label.textContent = chosen.title ? '\u00b7 ' + chosen.title : '';
      renderCheck();
    });
    observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    if (dialog.open) { loadShops(); renderCheck(); }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      errorBox.hidden = true;
      var data = {};
      new FormData(form).forEach(function (v, k) { data[k] = typeof v === 'string' ? v.trim() : v; });
      data.variantId = currentVariantId(dialog);
      data.turnstileToken = token;
      data.source = dialog.dataset.a3PbSource || 'page'; // 'nudge' when opened from the "Seen it cheaper?" card
      if (!data.competitorUrl) return showError('Tell us where you saw it: paste the link, or type the shop\u2019s name or website.', 'competitorUrl');
      if (!data.price) return showError('Please enter the price you found.', 'price');
      if (!data.name) return showError('Please enter your name.', 'name');
      if (!data.email || data.email.indexOf('@') < 1) return showError('Please enter your email address.', 'email');
      if (sitekey && !token) return showError('Please complete the security check.');

      submit.disabled = true; submit.textContent = 'Sending…';
      fetch('/apps/price-beat/request', {
        method: 'POST',
        headers: { 'content-type': 'application/json', accept: 'application/json' },
        body: JSON.stringify(data),
        credentials: 'same-origin'
      }).then(function (r) {
        return r.json().catch(function () { return { ok: false, message: 'Sorry, something went wrong. Please try again.' }; });
      }).then(function (j) {
        if (j && j.ok) {
          form.hidden = true;
          dialog.querySelector('.a3-pb__intro').hidden = true;
          dialog.querySelector('[data-a3-pb-ref]').textContent = j.ref;
          done.hidden = false; done.focus();
          return;
        }
        showError((j && j.message) || 'Sorry, something went wrong. Please try again.', j && j.field);
        if (window.turnstile && widgetId !== null) { window.turnstile.reset(widgetId); token = ''; }
      }).catch(function () {
        showError('Sorry, we couldn’t send your request. Please check your connection and try again.');
      }).finally(function () {
        submit.disabled = false; submit.textContent = 'Send my Price Beat request';
      });
    });
  }

  // "Price Beat promise" line beside the price (Joshua, 21 Oct 2026): opens this form instead of the Price Beat page.
  // Delegated, because the price block is re-rendered when the variant changes.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-a3-pb-open]');
    var dialog = link && document.querySelector('dialog[data-a3-pb]');
    if (!dialog) return;
    e.preventDefault();
    dialog.dataset.a3PbSource = link.getAttribute('data-a3-pb-open');
    if (!dialog.open) dialog.showModal();
  });

  function init() {
    document.querySelectorAll('dialog[data-a3-pb]').forEach(function (dialog) {
      setup(dialog);
      // Each opening says where it came from ('nudge', 'price'); the tile sends the default 'page'.
      dialog.addEventListener('close', function () { delete dialog.dataset.a3PbSource; });
    });
    // While the line is switched off, ?pb-preview shows it (as ?pbn-preview does for the card).
    // A class (not p.hidden) so it survives the price block being re-rendered on a variant change.
    if (/[?&]pb-preview\b/.test(location.search)) document.documentElement.classList.add('a3-pb-preview');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
